import * as fbPixel from "./fbPixel";

export const isFbPixelScriptAvailable = () => {
    return !!window._fbq?.loaded;
};

export const isFbPixelInitialized = (pixelId: string) => {
    if (typeof window._fbq?.getState !== "function") {
        return false;
    }

    const pixelState = window._fbq.getState();
    return !!pixelState?.pixels?.some((pixel) => pixel.id === pixelId);
};

export const initializeFbPixel = (pixelId: string) => {
    window.fbq("init", pixelId);
};

export const injectFbPixelScript = () => {
    const scriptTag = document.createElement("script");
    // The script we're injecting is only defining a function which loads the
    // additional Facebook logic asychronously.  Injecting this script tag will
    // not block the browser, and allows us to call the `fbq` method without
    // needing to wait for the additional third-party logic to load.
    scriptTag.async = false;
    scriptTag.innerHTML = `
        ! function(f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function() {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    `;

    window.document.getElementsByTagName("head")[0].appendChild(scriptTag);
};

export const sendFbEvent = (pixelId: string, eventArgs: [string, string, object]) => {
    if (!fbPixel.isFbPixelScriptAvailable()) {
        fbPixel.injectFbPixelScript();
    }

    if (!fbPixel.isFbPixelInitialized(pixelId)) {
        fbPixel.initializeFbPixel(pixelId);
    }

    window.fbq(...eventArgs);
};
